'use strict';
require('../../modules/es.array.iterator');
require('../../modules/es.object.to-string');
require('../../modules/es.weak-map');
require('../../modules/es.weak-map.get-or-insert');
require('../../modules/es.weak-map.get-or-insert-computed');
var path = require('../../internals/path');

module.exports = path.WeakMap;
